module.exports = __webpack_public_path__ + "static/media/ENDOCLINIC_LOGO_Q-1.446eef91.png";